import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  IconButton,
  Typography,
} from '@mui/material';
import RadioUnchecked from '@mui/icons-material/RadioButtonUnchecked';
import RadioChecked from '@mui/icons-material/CheckCircle';
import CheckboxUnchecked from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckboxChecked from '@mui/icons-material/CheckBox';
import EditIcon from '@mui/icons-material/Edit';

export function CheckboxButton(props) {
  const {
    SubActionIcon = EditIcon,
    error,
    helperText,
    checked,
    label,
    subLabel,
    onSubActionClick,
    color = 'primary',
    radio = true,
    sx,
    ...passThroughProps
  } = props;

  const CheckedIcon = radio ? RadioChecked : CheckboxChecked;
  const UncheckedIcon = radio ? RadioUnchecked : CheckboxUnchecked;

  const uncheckedStyle = {
    boxShadow: error
      ? undefined
      : `0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.20)`,
  };

  const checkedStyle = {
    boxShadow: error
      ? undefined
      : `2px 0px 4px 0px rgba(0, 0, 0, 0.25) inset, 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;`,
  };

  const button = (
    <FormControlLabel
      role="button"
      sx={{
        height: 48,
        margin: 0,
        px: 1,
        py: 0,
        borderRadius: '5px',
        overflow: 'hidden',
        border: (theme) =>
          error ? `1px solid ${theme.palette.error.main}` : undefined,
        background: (theme) => theme.palette.grey[50],
        ...(checked ? checkedStyle : uncheckedStyle),
        ...sx,

        '& .MuiCheckbox-root': {
          position: 'absolute',
          ml: -1000,
        },

        '& .MuiFormControlLabel-label': {
          flex: 1,
        },
      }}
      checked={checked}
      control={<Checkbox />}
      label={buildLabel()}
      {...passThroughProps}
    />
  );

  if (!helperText) return button;

  return (
    <FormControl error sx={{ width: sx.width }}>
      {button}
      <FormHelperText sx={{ m: 0 }}>{helperText}</FormHelperText>
    </FormControl>
  );

  function buildLabel() {
    return (
      <Box sx={{ width: '100%', display: 'flex', alignItems: 'center' }}>
        <Box sx={{ fontSize: 23, display: 'flex', alignItems: 'center' }}>
          {checked ? (
            <CheckedIcon
              fontSize="inherit"
              color={color === 'primary' ? 'inherit' : 'primary'}
            />
          ) : (
            <UncheckedIcon fontSize="inherit" />
          )}
        </Box>
        <Box sx={{ ml: 1, flex: 1, pr: 1 }}>
          {[label, subLabel].filter(Boolean).map((text, i) => (
            <Typography
              sx={{
                lineHeight: i ? 0.7 : 1.3,
                fontSize: i ? '10px !important' : undefined,
              }}
              variant="body2"
              component="div"
              color="inherit"
              key={i}
            >
              {text}
            </Typography>
          ))}
        </Box>
        {onSubActionClick ? (
          <IconButton color="inherit" onClick={onSubActionClick}>
            <SubActionIcon />
          </IconButton>
        ) : null}
      </Box>
    );
  }
}
